import React from "react";

const tvChannels = ["Top Channel", "Klan", "RTSH 1", "Vizion Plus"];
const muajt = [
  "Janar",
  "Shkurt",
  "Mars",
  "Prill",
  "Maj",
  "Qershor",
  "Korrik",
  "Gusht",
  "Shtator",
  "Tetor",
  "Nëntor",
  "Dhjetor",
];

function ModelViewReklmaSekonda({ tableContent }) {
  return tableContent !== undefined && tableContent !== null ? (
    <table
      border="1"
      cellPadding="5"
      cellSpacing="0"
      style={{ borderCollapse: "collapse", width: "100%", textAlign: "center" }}
    >
      <thead style={{ backgroundColor: "#c62828", color: "white" }}>
        <tr>
          <th rowSpan="2">Muaji</th>
          {tvChannels.map((channel) => (
            <th colSpan="2" key={channel}>
              {channel}
            </th>
          ))}
        </tr>
        <tr>
          {tvChannels.map((channel) => (
            <React.Fragment key={channel}>
              <th>
                <i>Koha në sekonda</i>
              </th>
              <th>Nr.i Reklamave</th>
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {muajt.map((muaji) => {
          const monthData = tableContent[muaji] || [];

          const channelMap = {};
          monthData.forEach((entry) => {
            const tv = entry.TV.trim();
            channelMap[tv] = entry;
          });

          return (
            <tr key={muaji}>
              <td>
                <strong>{muaji}</strong>
              </td>
              {tvChannels.map((channel) => {
                const entry = channelMap[channel] || {};
                return (
                  <React.Fragment key={channel}>
                    <td>{entry["Koha në sekonda"] || "-"}</td>
                    <td>{entry["Nr.i Reklamave"] || "-"}</td>
                  </React.Fragment>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <div>Nuk ka te dhena</div>
  );
}

export default ModelViewReklmaSekonda;
